import React from 'react'
import './AfficherPartiePerdu.scss'

export default function AfficherPartieGagne({score, niveauSuivant}) {
    return (
        <div className="modal">
            <div className="popup">
                <p className='msg_perdu'>Bravo tu as trouvé toutes les paires</p>
                <p className='msg_score'>Bonus temps : 60</p>
                <p className='msg_score'>Ton score : {score}</p>
                <button className="btn_rejouer" onClick={niveauSuivant}>NIVEAU SUIVANT</button>
            </div>
        </div>
    )
}
